import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

import {Job} from '../models';
import {HttpParams} from '@angular/common/http';
import {map} from 'rxjs/operators';
import {IQaModel} from '../models/qa.model';

@Injectable({
  providedIn: 'root'
})
export class JobsService {
  JOBS_ENDPOINT = '/jobs';
  constructor(private apiService: ApiService) { }

  get(config): Observable<any> {
    const params = {};

    Object.keys(config.filters)
      .forEach((key) => {
        if (config.filters[key]) {
          params[key] = config.filters[key];
        }
      });
    return this.apiService.get(environment.endpoint + this.JOBS_ENDPOINT + '/query', new HttpParams({fromObject: params}));
  }

  post(data: Job, action: string, questions?: IQaModel[]) {
    return this.apiService.post(environment.endpoint + this.JOBS_ENDPOINT, {job: data, mode: action, qa: questions});
  }

  put(data: Job, id: string): Observable<any> {
    return this.apiService.put(environment.endpoint + this.JOBS_ENDPOINT + '/' + id, {job: data});

  }

  delete(id: string): Observable<any> {
    return this.apiService.delete(environment.endpoint + this.JOBS_ENDPOINT + '/' + id);
  }

  getJob(id: string) {
    return this.apiService.get(environment.endpoint + this.JOBS_ENDPOINT + '/' + id);
  }

  publish(id: string) {
    return this.apiService.put(environment.endpoint + this.JOBS_ENDPOINT + '/publish/' + id);

  }

  count(accountId: string): Observable<any> {
    return this.apiService.get(environment.endpoint + this.JOBS_ENDPOINT + '/?accountId=' + accountId);
  }

  hide(id: string, val: boolean): Observable<any> {
    return this.apiService.put(environment.endpoint + this.JOBS_ENDPOINT + '/' + id, {job: {hidden: val}});
  }

  repost(id: any): Observable<any> {
    return this.apiService.put(environment.endpoint + this.JOBS_ENDPOINT + '/repost/' + id);
  }

  getJobCandidates(id: string, p: number) {
    const params = {
      page: p,
      limit: 20
    };
    // @ts-ignore
    return this.apiService.get(environment.endpoint + this.JOBS_ENDPOINT + '/candidates/' + id, new HttpParams( {fromObject: params}));
  }

  exportCandidates(id: string) {
    return this.apiService.get(environment.endpoint + this.JOBS_ENDPOINT + '/candidates/export/' + id);
  }

  createRepost(id: string, data: any) {
    return this.apiService.post(environment.endpoint + this.JOBS_ENDPOINT + '/repost/' + id, {time: data});
  }

  getRepost(id: string) {
    return this.apiService.get(environment.endpoint + this.JOBS_ENDPOINT + '/repost/' + id);
  }

  cancelRepost(id: string) {
    return this.apiService.delete(environment.endpoint + this.JOBS_ENDPOINT + '/repost/' + id);
  }

  updateApplication(id: string, data: any) {
    return this.apiService.put(environment.endpoint + this.JOBS_ENDPOINT + '/job-application/' + id, data);
  }

  saveQa(qa: IQaModel, id: string) {
    return this.apiService.post( environment.endpoint + this.JOBS_ENDPOINT + '/add-question/' + id, qa);
  }

  updateQa(qa: IQaModel) {
    return this.apiService.put(environment.endpoint + this.JOBS_ENDPOINT + '/question/' + qa._id, qa);
  }

  deleteQa(id: string) {
    return this.apiService.delete( environment.endpoint + this.JOBS_ENDPOINT + '/question/' + id);
  }

  searchCandidate(jobId: string, val: string, field: string) {
    return this.apiService.get(environment.endpoint + `/candidates/search/${jobId}/${field}?q=${val}`);
  }
}
